import { WebStorageStateStore } from "oidc-client-ts";

// 1. Configuración de OIDC (QUITA EL "export" DE AQUÍ ABAJO)
const cognitoConfig = {  // <--- SOLO "const", NO "export const"
  authority: `https://cognito-idp.${process.env.REACT_APP_COGNITO_REGION}.amazonaws.com/${process.env.REACT_APP_USER_POOL_ID}`,
  client_id: process.env.REACT_APP_USER_POOL_CLIENT_ID,
  redirect_uri: window.location.origin,
  response_type: 'code',
  scope: 'openid email profile',

  // --- SEGURIDAD CRÍTICA (Pentest Fix) ---
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  automaticSilentRenew: true,

  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },

  onSignoutCallback: () => {
    window.sessionStorage.clear();
    window.localStorage.clear();
  }
};

// 2. Función de Logout
const signOutRedirect = () => {
  const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN;
  const clientId = process.env.REACT_APP_USER_POOL_CLIENT_ID;
  const logoutUri = window.location.origin;

  if (!cognitoDomain) {
    console.error("Falta definir REACT_APP_COGNITO_DOMAIN en .env");
    window.sessionStorage.clear();
    window.location.reload();
    return;
  }

  const domain = `https://${cognitoDomain}`;
  window.location.href = `${domain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
};

// 3. Exportación final (AQUÍ ES DONDE SE EXPORTA REALMENTE)
export { cognitoConfig, signOutRedirect };
